import{isPrimaryPointer as r}from"./utils/is-primary-pointer.mjs.js";function t(r,t="page"){return{point:{x:r[`${t}X`],y:r[`${t}Y`]}}}const i=i=>o=>r(o)&&i(o,t(o));export{i as addPointerInfo,t as extractEventInfo};
